/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    bool, object, string, func,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';

import { deepObjectExtend } from '../../../utils/object';
import { main as mainStyle } from '../../../style/main';
import SubscriptionGiftForm from './SubscriptionEditGiftMessage';

const styles = ({ typography, palette }) => deepObjectExtend(mainStyle(typography, palette), {
    recipientDialogRoot: {
        width: '100%',
        boxSizing: 'border-box',
        alignItems: 'normal',
        height: '100%',
    },
    recipientDialogPaper: {
        boxSizing: 'border-box',
        borderRadius: '0',
        margin: '0 19.5px',
        boxShadow: '0px 0px 20px 6px rgba(0,0,0,0.5)',
        width: '100%',
        maxWidth: '670px',
        overflowY: 'auto',
        '@media screen and (min-width: 768px)': {
            minWidth: '55%',
            maxHeight: '600px',
            height: '91%',
        },
    },
});

function SubscriptionGiftFormDialog({
    classes, isOpen, ruleId, handleEditGiftClose, subscriptionsGiftMessage, selectedSubscription,
}) {
    return (
        <Dialog
            data-testid="subscription-gift-form-modal"
            open={isOpen}
            classes={{
                root: classes.recipientDialogRoot,
                paper: classes.recipientDialogPaper,
            }}
        >
            <SubscriptionGiftForm
                getAuthor
                getYourMessage
                ruleId={ruleId}
                closeForm={handleEditGiftClose}
                selectedSubscription={selectedSubscription}
                giftMessageText={subscriptionsGiftMessage}
            />
        </Dialog>
    );
}

SubscriptionGiftFormDialog.propTypes = {
    classes: object.isRequired,
    isOpen: bool,
    subscriptionsGiftMessage: string,
    handleEditGiftClose: func,
    ruleId: string.isRequired,
    selectedSubscription: object.isRequired,
};
SubscriptionGiftFormDialog.defaultProps = {
    isOpen: false,
    handleEditGiftClose: () => { },
    subscriptionsGiftMessage: '',
};
export default withStyles(styles, { withTheme: true })(SubscriptionGiftFormDialog);
